import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'SMPL Digital';
const BASE_URL = 'https://smpldigital.co.uk';
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.png`;

interface SEOProps {
  title: string;
  description: string;
  /** Canonical path, e.g. "/services/seo". Defaults to current pathname. */
  path?: string;
  /** Override OG image URL */
  ogImage?: string;
  /** Set to "noindex,nofollow" for legal/utility pages */
  robots?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  path,
  ogImage = DEFAULT_OG_IMAGE,
  robots,
}) => {
  const canonical = `${BASE_URL}${path ?? (typeof window !== 'undefined' ? window.location.pathname : '')}`;
  const fullTitle = `${title} | ${SITE_NAME}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {robots && <meta name="robots" content={robots} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
